<template>
  <div>
    <header class="modal-header">We are incredibly sorry for the inconvenience.</header>
    <section class="modal-body"><h1>We will have your crew fix the issue.</h1></section>
    <footer class="modal-footer">
      <LsButton
        text="Continue with fix"
        track-id="return_request_confirm_fix-submit"
        bg-color="primary"
        :loading="isFix && dispute.loadingStatus.isUpdating"
        :disabled="!isFix && dispute.loadingStatus.isUpdating"
        @click="submit()"
      />
      <LsButton
        text="No, I do not need a fix"
        track-id="return_request_confirm_fix-decline"
        bg-color="primary"
        :loading="!isFix && dispute.loadingStatus.isUpdating"
        :disabled="isFix && dispute.loadingStatus.isUpdating"
        @click="decline()"
      />
    </footer>
  </div>
</template>

<script>
import { LsButton } from '@/components/common';
import { mapActions, mapState } from 'vuex';
import { DISPUTE__REQUEST_FIX_OR_CREDIT, DISPUTE__DECLINE_FIX } from '@/store/types';

export default {
  name: 'ReturnRequestConfirmFix',
  components: {
    LsButton,
  },
  data() {
    return {
      isFix: false,
    };
  },
  computed: {
    ...mapState(['dispute']),
  },
  methods: {
    ...mapActions([DISPUTE__REQUEST_FIX_OR_CREDIT, DISPUTE__DECLINE_FIX]),
    submit() {
      this.isFix = true;
      this[DISPUTE__REQUEST_FIX_OR_CREDIT]({
        type: 'fix',
      });
    },
    decline() {
      this[DISPUTE__DECLINE_FIX]({
        onSuccess: this.$parent.close,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-footer {
  flex-direction: row;

  button:first-of-type {
    margin-right: 5px;
  }

  button:last-of-type {
    margin-left: 5px;
  }

  @media (max-width: $mobile-max-width) {
    flex-direction: column;

    button:first-of-type {
      margin-right: 0;
      margin-bottom: 10px;
    }

    button:last-of-type {
      margin-left: 0;
    }
  }
}
</style>
